import * as amplitude from '@amplitude/analytics-browser';
import { Types } from '@amplitude/analytics-browser';

import { AnalyticsItem } from '../AnalyticManager';

class Amplitude implements AnalyticsItem {
  apiKey: string;

  amplitudeClient: Types.BrowserClient;

  constructor(apiKey: string) {
    this.apiKey = apiKey;
    this.amplitudeClient = amplitude.createInstance();
  }

  init(userId: string): void {
    this.amplitudeClient.init(this.apiKey, userId ? userId : undefined, {
      autocapture: false,
    });
  }

  trackEvent(eventName: string, parameters?: Record<string, any>): void {
    this.amplitudeClient.logEvent(eventName, parameters);
  }

  setUserId(userId: string): void {
    this.amplitudeClient.setUserId(userId);
  }

  setUserProperties(properties: Record<string, string | number | boolean>): void {
    const identify = new amplitude.Identify();

    Object.entries(properties).forEach(([key, value]) => {
      identify.set(key, value);
    });

    this.amplitudeClient.identify(identify);
  }
}

export default Amplitude;
